const shared = {
  "shared-notfound-title": "No matching data found.",
  "shared-notfound-desc":
    "Please review the conditions or upload data to complete the setup.",

  "shared-reload-button1": "Reload",
  "shared-reload-button2": "Reloading...",
  "shared-create-button1": "Create New",
  "shared-create-button2": "Creating New...",

  "shared-fetch-api-success": "The data has been successfully fetched.",
  "shared-fetch-api-loading": "Freshing the data...",
  "shared-fetch-api-error": "Failed to fresh the data.",

  "shared-reload-api-success": "The data has been successfully refreshed.",
  "shared-reload-api-loading": "Refreshing the data...",
  "shared-reload-api-error": "Failed to refresh the data.",

  "shared-401-error-title": "Your session has expired",
  "shared-401-error-caption":
    "Please login again to continue using the service.",
  "shared-401-error-submit": "Login",

  "shared-400-error-title": "Bad Request Error",
  "shared-400-error-caption":
    "No available data found. Please review your filtering criteria and try again.",
  "shared-400-error-submit": "OK",

  "shared-422-error-title": "Unprocessable Content Error",
  "shared-422-error-caption":
    "No available data exists. Please complete the data upload and initial setup.",
  "shared-422-error-submit": "Go to Data Mgmt. Page",

  "shared-500-error-title": "Internal Server Error",
  "shared-500-error-caption":
    "We are very sorry. An unexpected error has occurred on the server, and data loading has failed. Please try again later.",
  "shared-500-error-submit": "OK",

  "shared-502-error-title": "Bad Gateway",
  "shared-502-error-caption":
    "We are very sorry. An unexpected error has occurred on the server, and data loading has failed. Please try again later.",
  "shared-502-error-submit": "OK",

  "shared-graph-average": "Average",

  "shared-query-button": "Filters",
  "shared-query-title": "Filters",

  // Model sync confirmation dialog
  "shared-model-sync-confirm-title": "Update Model Simultaneously",
  "shared-model-sync-confirm-body": "Update the model for both RCA and CATE?",
  "shared-model-sync-yes": "Yes",
  "shared-model-sync-no": "This page only",

  "shared-time-range-from": "From",
  "shared-time-range-to": "To",
  "shared-dropdown-please-select": "Please select.",
  "shared-dropdown-selected": "selected",
  "shared-dropdown-all-select": "Select All",
  "shared-dropdown-no-filter": "No filtering",
  "shared-dropdown-empty": "No results found.",
  "shared-dropdown-submit": "Apply",
  "shared-dropdown-clear": "Clear",

  "shared-input-please-enter": "Please enter.",
  "shared-input-search-by": "Search by...",

  "shared-table-filter-status": "Status",

  "shared-table-header-asc": "ASC",
  "shared-table-header-desc": "DESC",

  "shared-table-pagination-selected": "row(s) selected.",
  "shared-table-pagination-rows-per-page": "Rows per page",
  "shared-table-pagination-page": "Page",

  "shared-table-button-selected": "selected",
  "shared-table-button-submit": "Apply",
  "shared-table-button-edit": "Edit",
  "shared-table-button-active": "Activate",
  "shared-table-button-inactive": "Deactivate",
  "shared-table-button-delete": "Delete",
  "shared-table-button-mfa": "MFA Reset",
  "shared-table-button-share": "Share",
  "shared-table-button-save": "Save",
  "shared-table-button-export": "Export",
  "shared-table-button-download": "Download",

  "copied-success": "Copied successfully.",
  "download-success": "Download successfully.",

  active: "Active",
  inactive: "Inactive",
  pending: "Pending",
  deleted: "Deleted",

  using: "Using",
  unused: "Unused",

  selected: "Selected",
  unselected: "Unselected",

  missing_edge: "Missing Edge",
  not_found_edge: "Edge Not Found",
  duplicate_edges: "Duplicate Edges",
  incoming_edges: "Incoming Edge Limit Exceeded",
  layer_rule: "Layer Rule Violation",
  cycle_rule: "	Cyclic Connection Detected",

  query_bar: {
    time_grain: "Time Grain",
    time_range: "Time Range",
  },
  queue_panel: {
    empty: "There are no queues currently being processed.",
  },
  menu_panel: {
    slug: {
      assistant: "Assistant",
      dashboard: "Dashboard",
      graph: "Causal Graph",
      rca: "RCA",
      cate: "CATE",
      simulation: "Simulation",
      data_manager: "Data Mgmt.",
      augmentation: "Augmentation",
      account: "Account",
      docs: "Document",
      terms: "Terms of Use",
      policy: "Privacy Policy",
    },
    theme: {
      index: "Theme",
      light: "Light",
      dark: "Dark",
    },
    lang: {
      index: "Language",
      locale: "English",
    },
    auth: {
      login: "Login",
      logout: "Logout",
    },
  },
  project_panel: {
    api: {
      success: "The project has been switched successfully.",
      error: "Failed to switch the project.",
    },
    header: "Projects",
    please_select: "Please select.",
    empty: "No results found.",
    submit: "Apply",
  },
  header: {
    docs: "Document",
    logout: "Logout",
    login: "Login",
    lng: "JA",
  },
  footer: {
    top: "TOP",
    faq: "FAQ",
    docs: "Document",
    inquiry: "Inquiry Form",
    terms: "Terms of Use",
    policy: "Privacy Policy",
    security: "Information Security Policy",
    corp: "Corporate Site",
  },
  datetime: {
    just_now: "just now",
    seconds_ago: "{{count}} second ago",
    seconds_ago_plural: "{{count}} seconds ago",
    minutes_ago: "{{count}} minute ago",
    minutes_ago_plural: "{{count}} minutes ago",
    hours_ago: "{{count}} hour ago",
    hours_ago_plural: "{{count}} hours ago",
    days_ago: "{{count}} day ago",
    days_ago_plural: "{{count}} days ago",
  },
  store_type: {
    add: "Add",
    new: "New",
  },
  imput_type: {
    liner: "Liner",
    zero: "Zero",
  },
  display: {
    display: "Display",
    hide: "Hide",
  },
  status: {
    idle: "Idle",
    loading: "Loading",
    success: "Success",
    error: "Error",
    unknown: "Unknown",
  },
  upload_status: {
    idle: "Upload pending",
    loading: "Uploading",
    success: "Upload complete",
    error: "Upload failed",
    unknown: "Unknown",
  },
};

export default shared;
